import { Typography } from "@mui/material";
import { useLocalizedProperty } from "../../utils";

export const TaskStatusText = (props) => {
    const getLocalizedProperty = useLocalizedProperty();
    const status_key = props.status?.status_key || "unknown";
    const statusText = getLocalizedProperty(props.status, "status_name");

    const colors = {
        Finalized: "#0B94D8", // Blue
        Scheduled: "#068e06", // Green
    };

    if (!(status_key in colors)) {
        return <Typography>{statusText}</Typography>;
    }

    return <Typography color={colors[status_key]}>{statusText}</Typography>;
};
